import { WalkerAvailabilityV6 } from '../../../../../types/api';
import { formatAvailabilityDate } from '../../../../../utils/formatAvailabilityDate';

type FilterDisabledDays = {
  availability: WalkerAvailabilityV6['availability'];
  startingDate?: Date;
}

export const filterDisabledDays = ({
  availability,
  startingDate = new Date(),
}: FilterDisabledDays) => Array.from(Array(31).keys()).reduce((acc, value) => {
  if (!availability?.length) {
    acc.push(new Date(startingDate.getFullYear(), startingDate.getMonth(), value));
    return acc;
  }
  const initialDate = new Date(startingDate);
  const date = new Date(initialDate.getFullYear(), initialDate.getMonth(), 1);
  date.setDate(date.getDate() + value);
  const dateKey = formatAvailabilityDate({
    initialDate: new Date(date),
  });
  const dateFound = availability.find((item) => item.date === dateKey);

  if (dateFound) {
    if (!dateFound.available) {
      acc.push(date);
    }
  } else {
    acc.push(date);
  }
  return acc;
}, []);
